import { useTranslations } from "next-intl";
import { Fragment } from "react/jsx-runtime";
import { DataField, Stack } from "@leabankab/component-library";
import { useConstantOptions } from "../../../customer-information/hooks/use-constant-options";
import { LoanSummaryPageContext } from "../../types";

interface Props {
	context: LoanSummaryPageContext;
}

export const PersonalInfo = ({ context }: Props) => {
	const t = useTranslations("pages.SummaryPage");
	const tCommon = useTranslations("common");
	const countryOptions = useConstantOptions("countries");

	const { citizenship, isPep } = context;

	const citizenshipValue = citizenship.map((value) => (
		<Fragment key={value}>{countryOptions[value] ?? value}</Fragment>
	));

	return (
		<Stack>
			<DataField label={t("common.citizenship")} value={citizenshipValue} />
			<DataField
				label={t("common.pep")}
				value={tCommon(isPep ? "yes" : "no")}
				divider={false}
			/>
		</Stack>
	);
};
